<section id="hero" class="hero section dark-background">
  <div class="info d-flex align-items-center">
    <div class="container">
      <div class="row justify-content-center" data-aos="fade-up" data-aos-delay="100">
        <div class="col-lg-6 text-center">
          <h2>Ihr Tor zu Deutschland – Arbeiten, Lernen & Erfolgreich sein!</h2>
          <p>Finden Sie Ihren Traumjob oder Ihre Ausbildungsmöglichkeit in Deutschland. Entdecken Sie Top-Karrieren in den Bereichen Gesundheitswesen, Handwerk, Gastgewerbe und mehr!</p>
          <div class="hero-btns">
            <a routerLink="/Jobs" class="hero-btn">Jobs erkunden</a>
            <a routerLink="/Contact" class="hero-btn hero-btn-primary">Kontaktieren Sie uns</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="hero-carousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
    <div class="carousel-item">
      <img src="assets/img/hero-carousel/hero-carousel-2.jpg" alt="">
    </div>
    <div class="carousel-item">
      <img src="assets/img/hero-carousel/hero-carousel-4.jpg" alt="">
    </div>
    <div class="carousel-item">
      <img src="assets/img/hero-carousel/hero-carousel-1.jpg" alt="">
    </div>
    <div class="carousel-item">
      <img src="assets/img/hero-carousel/hero-carousel-5.jpg" alt="">
    </div>
    <div class="carousel-item active">
      <img src="assets/img/hero-carousel/hero-carousel-3.jpg" alt="">
    </div>

    <a class="carousel-control-prev" href="#hero-carousel" role="button" data-bs-slide="prev">
      <span class="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
    </a>
    <a class="carousel-control-next" href="#hero-carousel" role="button" data-bs-slide="next">
      <span class="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
    </a>
  </div>
</section><!-- /Hero Section -->

<!-- Recent Blog Posts Section -->
<section id="recent-blog-posts" class="recent-blog-posts section">
  <!-- Section Title -->
  <div class="container section-title" data-aos="fade-up">
    <h2>Neueste Blogbeiträge</h2>
    <p>Erforderliche Unterstützung für innovative Lösungen und kreative Ideen</p>
  </div><!-- End Section Title -->

  <div class="container mt-5">
    <div class="row gy-5 artilce-slider pb-2" *ngIf="articles.length>0">
      <div
        class="artilce-slide col-xl-4 col-md-6 d-flex"
        style="margin-inline: 20px !important; margin-bottom: 10px !important;"
        *ngFor="let article of articles"
        data-aos="fade-up" data-aos-delay="100">
        <!-- Make post-item stretch -->
        <div class="post-item position-relative d-flex flex-column h-100 w-100">
          <div class="post-img position-relative overflow-hidden">
            <img *ngIf="article.coverUrl" [src]="article.coverUrl" class="img-fluid" alt="{{ article.title }}">
            <span class="post-date">{{ article.publishedAt?.toDate() | date:'d. MMMM' }}</span>
          </div>

          <!-- Post content grows and pushes read more button down -->
          <div class="post-content d-flex flex-column flex-grow-1">
            <h3 class="post-title">{{ article.title }}</h3>
            <div class="meta d-flex align-items-center">
              <div class="d-flex align-items-center">
                <i class="bi bi-person"></i>
                <span class="ps-2">{{ article.authorName || 'Unbekannt' }}</span>
              </div>
              <span class="px-3 text-black-50">/</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-folder2"></i>
                <span class="ps-2">{{ article.category || 'Ohne Kategorie' }}</span>
              </div>
            </div>
            <hr class="mt-auto">
            <a [routerLink]="['/Article', article.id]" class="readmore stretched-link">
              <span>Weiterlesen</span><i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="spinner-border text-primary" role="status" *ngIf="showArticleSpinner" style="display: flex; align-items: center; justify-content: center; margin: auto;">
      <span class="visually-hidden">Lädt...</span>
    </div>
  </div>
</section><!-- /Recent Blog Posts Section -->

<app-about [showHero]="false"></app-about>

<app-how-work [showHero]="false"></app-how-work>

<section id="services" class="services section">
  <div class="container section-title" data-aos="fade-up">
    <h2>Jobs</h2>
    <p>Wir unterstützen Sie in diesen Bereichen.</p>
  </div><!-- End Section Title -->
  <div class="container d-flex flex-column justify-content-center" *ngIf="jobs.length>0">
    <div class="row gy-4">
      <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100" *ngFor="let job of jobs">
        <div class="service-item position-relative">
          <figure>
            <img [src]="job.image" alt="Unser Team" style="width:100%; height: auto;">
          </figure>
          <h3>{{job.title}}</h3>
          <p>{{sharedService.getSubText(job.text)}}</p>
          <div class="d-flex align-items-center justify-content-between">
            <a *ngIf="job" [routerLink]="['/job-details', job.id]">
              Weiterlesen <i class="bi bi-arrow-right"></i>
            </a>
            <button *ngIf="job"
                    (click)="navigateToApplicationComponent(job.id)"
                    class="btn btn-primary btn-sm fw-bold mt-">
              Jetzt bewerben
            </button>
          </div>
        </div>
      </div>
    </div>

    <button class="primary-btn" style="margin:50px auto !important; width: 200px;" routerLink="/Jobs">Alle Jobs ansehen</button>
  </div>

  <div class="spinner-border text-primary" role="status" *ngIf="showJobSpinner" style="display: flex; align-items: center; justify-content: center; margin: auto;">
    <span class="visually-hidden">Lädt...</span>
  </div>
</section><!-- /Services Section -->

<!-- Faq Section -->
<section id="faq" class="faq section">
  <div class="container section-title" data-aos="fade-up">
    <h2>Häufig gestellte Fragen</h2>
    <p>Häufig gestellte Fragen</p>
  </div><!-- End Section Title -->

  <div class="container">
    <div class="row gy-4">
      <div data-aos="fade-up" data-aos-delay="200">
        <div class="faq-container">
          <div class="faq-item" [ngClass]="{'faq-active':index==0}" *ngFor="let faq of faqs;let index = index">
            <h3><span class="num">{{index+1}}.</span> <span>{{faq.question}}</span></h3>
            <div class="faq-content">
              <p>{{faq.answer}}</p>
            </div>
            <i class="faq-toggle bi bi-chevron-right"></i>
          </div><!-- End Faq item-->
        </div>
      </div>
    </div>
  </div>
</section><!-- /Faq Section -->